// /frontend/src/components/AdminRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuthToken } from "../api/adminAuthService";

const AdminRoute = ({ children }) => {
  const location = useLocation();

  // อ่านโทเคนของ "แอดมิน"
  const adminToken = getAuthToken();

  if (!adminToken) {
    console.warn("🚫 [AdminRoute] Missing admin token -> /admin/login");
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }

  // ผ่านได้
  return children;
};

export default AdminRoute;
